import { SidebarMenuItem } from '@app/_interfaces';
import { environment } from '@env/environment.local';

export const sidebar: SidebarMenuItem[] = [
    {
        id: 'home',
        label: 'Home',
        icon: 'home',
        url: 'dashboard',
        availableOnlyInFeature: [],
        availableOnlyInFeatureName: [],
        show: true,
        children: [],
    },
    {
        id: 'website',
        label: 'Sitio Web',
        icon: 'browser',
        url: 'website',
        availableOnlyInFeature: [],
        availableOnlyInFeatureName: [],
        permissions: [
            'website-pages',
            'website-basic_info',
            'website-contact_info',
            'website-inquiries',
            'website-design',
            'website-settings',
        ],
        show: true,
        children: [
            {
                id: 'pages',
                label: 'Páginas',
                url: 'website/pages',
                image: '/assets/img/servicios/icons/taxi-505.png',
                availableOnlyInFeature: [],
                availableOnlyInFeatureName: [],
                permissions: ['website-pages'],
                show: true,
            },
            {
                id: 'basic-info',
                label: 'Información Básica',
                url: 'website/basic-info',
                image: '/assets/img/servicios/icons/taxi-505.png',
                availableOnlyInFeature: [],
                availableOnlyInFeatureName: [],
                permissions: ['website-basic_info'],
                show: true,
            },
            {
                id: 'contact-data',
                label: 'Información de contacto',
                url: 'website/contact-data',
                image: '/assets/img/servicios/icons/taxi-505.png',
                availableOnlyInFeature: [],
                availableOnlyInFeatureName: [],
                permissions: ['website-contact_info'],
                show: true,
            },
            {
                id: 'queries',
                label: 'Consultas',
                url: 'website/queries',
                image: '/assets/img/servicios/icons/taxi-505.png',
                availableOnlyInFeature: [],
                availableOnlyInFeatureName: [],
                permissions: ['website-inquiries'],
                show: true,
            },
            {
                id: 'design',
                label: 'Diseño',
                url: 'website/design',
                image: '/assets/img/servicios/icons/taxi-505.png',
                availableOnlyInFeature: [],
                availableOnlyInFeatureName: [],
                permissions: ['website-design'],
                show: true,
            },
            {
                id: 'settings',
                label: 'Ajustes',
                url: 'website/settings',
                image: '/assets/img/servicios/icons/taxi-505.png',
                availableOnlyInFeature: [],
                availableOnlyInFeatureName: [],
                permissions: ['website-settings'],
                show: true,
            },
        ],
    },
    {
        id: 'domains',
        label: 'Dominios',
        icon: 'globe',
        url: 'domains',
        availableOnlyInFeature: [],
        availableOnlyInFeatureName: [],
        permissions: ['domains'],
        show: true,
        children: [],
    },
    {
        id: 'e-mails',
        label: 'Correos electrónicos',
        icon: 'envelope',
        url: 'e-mails',
        availableOnlyInFeature: [],
        availableOnlyInFeatureName: [],
        permissions: ['emails'],
        show: true,
        children: [],
    },
    {
        id: 'tools',
        label: 'Herramientas',
        icon: 'tools',
        url: 'tools',
        availableOnlyInFeature: [],
        availableOnlyInFeatureName: [],
        permissions: ['tools-integrations', 'tools-seo'],
        show: true,
        children: [
            {
                id: 'integrations',
                label: 'Integraciones & apps',
                url: 'tools/integrations',
                image: '/assets/img/servicios/icons/taxi-505.png',
                availableOnlyInFeature: [],
                availableOnlyInFeatureName: [],
                permissions: ['tools-integrations'],
                show: true,
            },
            {
                id: 'seo-tools',
                label: 'Herramientas de SEO',
                url: 'tools/seo-tools',
                image: '',
                availableOnlyInFeature: [],
                availableOnlyInFeatureName: [],
                permissions: ['tools-seo'],
                show: true,
            },
        ],
    },
    {
        id: 'statistics',
        label: 'Estadísticas',
        icon: 'chart-line',
        url: 'statistics',
        availableOnlyInFeature: [],
        availableOnlyInFeatureName: [],
        permissions: ['analytics'],
        show: true,
        children: [],
    },
    {
        id: 'ecommerce',
        label: 'Tienda',
        icon: 'store',
        url: 'e-commerce',
        availableOnlyInFeature: [],
        availableOnlyInFeatureName: [],
        permissions: [
            'store-sales',
            'store-products',
            'store-categories',
            'store-tags',
            'store-shipping_methods',
            'store-payment_methods',
            'store-checkout',
            'store-customers',
            'store-coupons',
            'store-integrations',
            'store-design',
            'store-settings',
        ],
        show: true,
        children: [
            {
                id: 'sales',
                label: 'Ventas',
                url: 'e-commerce/sales',
                image: '/assets/img/servicios/icons/taxi-505.png',
                availableOnlyInFeature: [2], // 2 >>> tienda
                availableOnlyInFeatureName: ['tienda'],
                permissions: ['store-sales'],
                show: true,
            },
            {
                id: 'products',
                label: 'Productos',
                url: 'e-commerce/products',
                image: '/assets/img/servicios/icons/taxi-505.png',
                availableOnlyInFeature: [],
                availableOnlyInFeatureName: [],
                permissions: ['store-products'],
                show: true,
            },
            {
                id: 'categories',
                label: 'Categorías',
                url: 'e-commerce/categories',
                image: '/assets/img/servicios/icons/taxi-505.png',
                availableOnlyInFeature: [],
                availableOnlyInFeatureName: [],
                permissions: ['store-categories'],
                show: true,
            },
            {
                id: 'tags',
                label: 'Etiquetas',
                url: 'e-commerce/tags',
                image: '/assets/img/servicios/icons/taxi-505.png',
                availableOnlyInFeature: [],
                availableOnlyInFeatureName: [],
                permissions: ['store-tags'],
                show: true,
            },
            {
                id: 'shipping-methods',
                label: 'Métodos de envío',
                url: 'e-commerce/shipping-methods',
                image: '/assets/img/servicios/icons/taxi-505.png',
                availableOnlyInFeature: [2], // 2 >>> tienda
                availableOnlyInFeatureName: ['tienda'],
                permissions: ['store-shipping_methods'],
                show: true,
            },
            {
                id: 'payment-methods',
                label: 'Métodos de pago',
                url: 'e-commerce/payment-methods',
                image: '/assets/img/servicios/icons/taxi-505.png',
                availableOnlyInFeature: [2], // 2 >>> tienda
                availableOnlyInFeatureName: ['tienda'],
                permissions: ['store-payment_methods'],
                show: true,
            },
            {
                id: 'customize-checkout',
                label: 'Checkout',
                url: 'e-commerce/customize-checkout',
                image: '/assets/img/servicios/icons/taxi-505.png',
                availableOnlyInFeature: [2, 11], // 2 >>> tienda / 11 custom_checkout
                availableOnlyInFeatureName: ['tienda', 'custom_checkout'],
                permissions: ['store-checkout'],
                show: true,
            },
            {
                id: 'customer-management',
                label: 'Gestión de Clientes',
                url: 'e-commerce/customer-management',
                image: '/assets/img/servicios/icons/taxi-505.png',
                availableOnlyInFeature: [2], // 2 >>> tienda
                availableOnlyInFeatureName: ['tienda'],
                permissions: ['store-customers'],
                show: true,
            },
            {
                id: 'discount-coupons',
                label: 'Cupones de descuento',
                url: 'e-commerce/discount-coupons',
                image: '/assets/img/servicios/icons/taxi-505.png',
                availableOnlyInFeature: [2], // 2 >>> tienda
                availableOnlyInFeatureName: ['tienda'],
                permissions: ['store-coupons'],
                show: true,
            },
            {
                id: 'sales-channels',
                label: 'Integraciones',
                url: 'e-commerce/sales-channels',
                image: '/assets/img/servicios/icons/taxi-505.png',
                availableOnlyInFeature: [],
                availableOnlyInFeatureName: [],
                permissions: ['store-integrations'],
                show: true,
            },
            {
                id: 'design-ecommerce',
                label: 'Diseño de tienda',
                url: 'e-commerce/design',
                image: '/assets/img/servicios/icons/taxi-505.png',
                availableOnlyInFeature: [],
                availableOnlyInFeatureName: [],
                permissions: ['store-design'],
                show: true,
            },
            {
                id: 'configurations',
                label: 'Configuraciones',
                url: 'e-commerce/configurations',
                image: '/assets/img/servicios/icons/taxi-505.png',
                availableOnlyInFeature: [],
                availableOnlyInFeatureName: [],
                permissions: ['store-settings'],
                show: true,
            },
        ],
    },
    {
        id: 'blog',
        label: 'BLOG',
        icon: 'blog',
        url: 'blog',
        availableOnlyInFeature: [],
        availableOnlyInFeatureName: [],
        permissions: ['blog-posts', 'blog-categories', 'blog-settings'],
        show: environment.enableBlog,
        children: [
            {
                id: 'blog-entries',
                label: 'Entradas',
                url: 'blog/entries',
                image: '/assets/img/servicios/icons/taxi-505.png',
                availableOnlyInFeature: [],
                availableOnlyInFeatureName: [],
                permissions: ['blog-posts'],
                show: true,
            },
            {
                id: 'blog-categories',
                label: 'Categorías',
                url: 'blog/categories',
                image: '/assets/img/servicios/icons/taxi-505.png',
                availableOnlyInFeature: [],
                availableOnlyInFeatureName: [],
                permissions: ['blog-categories'],
                show: true,
            },
            {
                id: 'blog-configuration',
                label: 'Configuración',
                url: 'blog/configuration',
                image: '/assets/img/servicios/icons/taxi-505.png',
                availableOnlyInFeature: [],
                availableOnlyInFeatureName: [],
                permissions: ['blog-settings'],
                show: true,
            },
        ],
    },
];
